import React from "react";
import { Outlet } from "react-router-dom";

interface LayoutWrapperProps {
  header: React.ReactNode;
  left: React.ReactNode;
  right: React.ReactNode;
}

const LayoutWrapper: React.FC<LayoutWrapperProps> = ({
  header,
  left,
  right,
}) => {
  return (
    <div className="container-fluid d-flex flex-column vh-100 p-0">
      {/* Header (hauteur auto) */}
      <div className="header-height">{header}</div>

      {/* Contenu qui prend le reste */}
      <div className="row g-0 flex-grow-1 overflow-hidden h-100"  style={{ minHeight: 0 }}>
        {/* Colonne gauche */}
        <div className="col-md-6 d-flex flex-column bg-light h-100"  style={{ minHeight: 0 }}>
          <div className="overflow-auto flex-grow-1">{left}</div>
        </div>

        {/* Colonne droite */}
        <div className="col-md-6 d-none d-md-flex p-0 h-100">
          <div className="w-100 overflow-auto flex-grow-1">{right}</div>
        </div>
      </div>
    </div>
  );
};

export default LayoutWrapper;
